import { render, staticRenderFns } from "./OrderMoreOptionsDisabled.vue?vue&type=template&id=12639b2e&"
import script from "./OrderMoreOptionsDisabled.vue?vue&type=script&lang=js&"
export * from "./OrderMoreOptionsDisabled.vue?vue&type=script&lang=js&"
import style0 from "./OrderMoreOptionsDisabled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports